const __WEBPACK_NAMESPACE_OBJECT__ = require("pkg-banner-webpack-plugin");;